export function FlagBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-testid="midterms-flag-backdrop">
      <div
        className="absolute inset-0 opacity-[0.1]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(180deg, #E81B23 0px, #E81B23 44px, #ffffff 44px, #ffffff 88px)",
        }}
      />
      <div
        className="absolute left-0 top-0 w-[46%] h-[54%] bg-[#0A1C52]/90"
        style={{
          backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.22) 2px, transparent 2.5px)",
          backgroundSize: "34px 30px",
          backgroundPosition: "8px 6px",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#07112e]/60 via-[#07112e]/80 to-[#07112e]" />
      <div className="absolute inset-0 midterms-grain" />
    </div>
  );
}
